import { useMonthLabel, useT } from "../i18n/I18nContext";

interface Props {
  year: number;
  month: number;
  onChange: (year: number, month: number) => void;
  /** Restrict navigation. Defaults to allowing only current and previous month. */
  allowedRange?: { from: { year: number; month: number }; to: { year: number; month: number } };
}

export function MonthSwitcher({ year, month, onChange, allowedRange }: Props) {
  const t = useT();
  const monthLabel = useMonthLabel();

  const navigate = (delta: number) => {
    let m = month + delta;
    let y = year;
    while (m < 1) {
      m += 12;
      y -= 1;
    }
    while (m > 12) {
      m -= 12;
      y += 1;
    }
    if (allowedRange) {
      const cur = y * 12 + m;
      const from = allowedRange.from.year * 12 + allowedRange.from.month;
      const to = allowedRange.to.year * 12 + allowedRange.to.month;
      if (cur < from || cur > to) return;
    }
    onChange(y, m);
  };

  return (
    <div className="inline-flex items-center gap-1 rounded-xl border border-border bg-white p-1 shadow-sm">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="rounded-lg px-3 py-2 text-text-secondary hover:bg-surface-alt sm:px-2 sm:py-1"
        aria-label={t("month.prev")}
      >
        ◀
      </button>
      <div className="px-3 text-sm font-semibold text-portal-primary">
        {monthLabel(month)} {year}
      </div>
      <button
        type="button"
        onClick={() => navigate(1)}
        className="rounded-lg px-3 py-2 text-text-secondary hover:bg-surface-alt sm:px-2 sm:py-1"
        aria-label={t("month.next")}
      >
        ▶
      </button>
    </div>
  );
}
